import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "table-container",
        class: _normalizeClass(["relative w-full", $setup.cn('w-full caption-bottom text-sm', $setup.props.wrapperClass)])
    }, [
        _createElementVNode("table", {
            "data-slot": "table",
            class: _normalizeClass($setup.cn('w-full caption-bottom text-sm', $setup.props.class))
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */)
    ], 2 /* CLASS */));
}
